import { withFormikField } from "@/formikComponents";

import { CodelistGenericSelect, ICodelistGenericSelectProps } from "./../Codelists/CodelistsGeneric";

export const FormikCodelistGenericSelect = withFormikField<ICodelistGenericSelectProps>(CodelistGenericSelect);
